import moment from 'moment-timezone';

const timezoneConvert = (unconvertedDate, timezone = 'UTC', dateFormat) => {
  moment.tz.setDefault('UTC');

  const convertedDate = moment(unconvertedDate, 'YYYY-MM-DD HH:mm:ss')
    .tz(timezone)
    .format(dateFormat);
  return convertedDate;
};

export default timezoneConvert;
